export const ROLE_TYPES = {
  normal: 0,
  game: 1,
  everyone: 255,
  tourist: 254,
  punish: 253,
}

export const COLOR_PICK_IMG = 'https://static.max-c.com/static/heybox-chat/img/color-picker/palette.png';

// 权限组设置相关
export const DEFAULT_COLOR = 'var(--opacity-6)';

export const ONLY_SET_PERMISSION_TYPES = [253, 254, 255];
export const ROLE_CREATE = {
  name: '创建新权限组',
  id: '#create',
}

export const COLOR_SAMPLES = {
  bright: [
    '#1CBC9D', '#30CC71', '#3498DB', '#9B59B6', '#E91E63', '#F1C411', '#E67E23', '#E74D3C' ,'#95A6A6', '#607E8B'
  ],
  gamma: [
    '#10816A', '#1F8B4C', '#206695', '#71368A', '#AD1458', '#C27C0F', '#A84400', '#992D22' ,'#989C9F', '#546F7A'
  ]
}
export const COLOR_GRADIENTS = {
  // linear-gradient(90deg, #206695 0%, #1F8B4C 100%)
  bright: [
    '#4EA9E5,#36E57F', '#1CBC9D,#EDE611', '#9661FF,#34B1DB', '#8030FF,#CC4747', '#E835E8,#F1C411', 
    '#8AC6C6,#F1C411', '#ED286B,#E69E23', '#5EC6F2,#E76253' ,'#95A6A6,#EAEAEB', '#F4CF43,#F8F1BB'
  ],
  gamma: [
    '#206695,#1F8B4C', '#10816A,#C29B0F', '#6944B2,#277D99', '#5F32AD,#943A3A', '#AD14A5,#C27C0F', 
    '#55ABAB,#C27C0F', '#AD1D5D,#A85F00', '#226EA1,#91453D' ,'#4F6873,#989C9F', '#AE901E,#EBDC6C'
  ]
}

export const IS_GRADIENT_LIST_COUNT = 2

export const CHANNEL_ROLE_BTN_LIST = {
  FORBID:'forbid',
  SYNC:'sync',
  ALLOW:'allow'
}